export const enum RequestStatusType {
  /** черновик */
  draft = 'draft',
  /** на рассмотрении руководителя */
  consideredBySupervisor = 'consideredBySupervisor',
  /** одобрено руководителем */
  approvedBySupervisor = 'approvedBySupervisor',
  /** отклонено руководителем */
  rejectedBySupervisor = 'rejectedBySupervisor',
  /** на рассмотрении у HR */
  consideredByHR = 'consideredByHR',
  /** взято в работу HR */
  takenToWorkByHR = 'takenToWorkByHR',
  /** смена ответственного HR */
  changeResponsibleByHR = 'changeResponsibleByHR',
  /** одобрено HR */
  approvedByHR = 'approvedByHR',
  /** отклонено HR */
  rejectedByHR = 'rejectedByHR',
  /** отмено HR */
  canceledByHR = 'canceledByHR',
  /** готово HR */
  ready = 'ready',
}
